export const SET_STATUS="app/locations/SET_STATUS"
export const NEXT_PAGE="app/locations/NEXT_PAGE"
export const BACK_PAGE="app/locations/BACK_PAGE"
export const RESET_PAGE="app/locations/RESET_PAGE"
export const LOCATIONS_LOADING="app/locations/LOCATIONS_LOADING"
export const SET_SEARCH="app/locations/SET_SEARCH"
export const SET_SEARCH_VIEW="app/locations/SET_SEARCH_VIEW"
